import { REPORT_CONTEXT_MENU_SERVICE_NAME, ReportContextMenuServiceProvider } from './report.context-menu.service'

export const REPORT_SERVICES_MODULE_NAME = 'simax.services.report'

const module = angular.module(REPORT_SERVICES_MODULE_NAME, [])

module.provider(REPORT_CONTEXT_MENU_SERVICE_NAME, ReportContextMenuServiceProvider)
